import { aspectRatio } from '@helpers/aspectRatio';
import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h5 } from '@helpers/typography';
import CallButtonStyles from '@stories/Components/Buttons/CallButton/CallButton.styles';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  width: 100%;
  margin-top: auto;

  @media ${from(Device.TabletLarge)} {
    margin-top: unset;
    max-width: 800px;
  }
`;
const Inner = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  background-color: ${brand.white};

  @media ${from(Device.TabletLarge)} {
    flex-direction: row;
    border-radius: 16px;
  }
`;
const Close = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 100%;
  right: 0;
  width: 48px;
  height: 48px;
  color: ${brand.white};
  cursor: pointer;

  @media ${from(Device.TabletLarge)} {
    top: 0;
    bottom: auto;
    color: ${brand.actualBlack};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
const ImageWrapper = styled.div `
  position: relative;
  padding-bottom: ${aspectRatio(376, 184)}%;

  @media ${from(Device.TabletLarge)} {
    padding-bottom: unset;
    height: 100%;
    min-height: 480px;
    flex: 1 0 360px;
  }
`;
const Image = styled.img `
  position: absolute;
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: top center;
`;
const CtaOverlay = styled.a `
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 16px;
  right: 16px;
  background-color: ${brand.green.mid};
  color: currentColor;
  text-decoration: none;
  width: 68px;
  height: 68px;
  min-width: 68px;
  min-height: 68px;
  max-width: 104px;
  max-height: 104px;
  border-radius: 50%;

  @media ${from(Device.TabletLarge)} {
    width: 29%;
    height: ${aspectRatio(360, 480)}%;
  }
`;
const CtaOverlayText = styled.span `
  --font-clamp: clamp(0.7rem, 2.5vw, 16px);

  ${fonts.montserrat.extraBold};
  font-size: var(--font-clamp);
  line-height: 1.2;
  text-align: center;
  max-width: 86%;

  @media ${from(Device.TabletLarge)} {
    --font-clamp: clamp(1rem, 1.5vw, 16px);
  }
`;
const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 30px;
  text-align: center;

  ${CallButtonStyles.Container} {
    border-color: ${brand.black};
    padding: 10px 24px;

    @media ${from(Device.TabletLarge)} {
      padding: 22px 24px;
    }
  }

  ${CallButtonStyles.Icon} {
    width: 24px;
    height: 24px;
  }

  ${CallButtonStyles.Telephone} {
    margin: 0;
  }
`;
const Logo = styled.img `
  display: block;
  max-height: 48px;

  @media ${from(Device.TabletLarge)} {
    max-height: 145px;
  }
`;
const Title = styled.h3 `
  ${h5};
  margin: 0;

  @media ${until(Device.TabletLarge)} {
    font-size: 20px;
  }
`;
const Content = styled.div `
  ${contentStyles};
`;
const ContactWrapper = styled.div ``;
const ExitIntentPopupStyles = {
    Container,
    Inner,
    ImageWrapper,
    Image,
    CtaOverlay,
    CtaOverlayText,
    ContentWrapper,
    Logo,
    Title,
    Content,
    ContactWrapper,
    Close,
};
export default ExitIntentPopupStyles;
